import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { useFormikWrapper } from "../../../components/formik_wrapper";

import {
  ADDCREDENTIAL_REQ,
  DELETECREDENTIAL_REQ,
  EDITCREDENTIAL_REQ,
  GETCREDENTIALS_REQ,
  GETCREDENTIAL_REQ,
  RESET_STATE,
} from "../../../actions";
import {
  ADDCREDENTIAL_RESPONSE,
  DELETECREDENTIAL_RESPONSE,
  EDITCREDENTIAL_RESPONSE,
} from "../../../constants/action_types";

import Paginator from "../../../components/paginator";
import Search from "../../../components/search";
import DropDown from "../../../components/dropdown";
import { FlatButton } from "../../../components/buttons";
import { Popup } from "../../../components/pop-up";
import { Modal } from "flowbite-react";
import { SearchDropdown, TextArea, TextBox } from "../../../components/inputs";

function Credentials({ companyDetails }) {
  const dispatch = useDispatch();
  const credentialsList = useSelector(
    (state) => state.company.credentials?.list
  );
  const credentialDetails = useSelector(
    (state) => state.company.credentials?.details
  );
  const credentialUpdate = useSelector(
    (state) => state.company.update_response
  );

  const [credentialAction, setCredentialAction] = useState({ action: "init" });

  const limit = 6;

  const [providers, setProviders] = useState([]);

  const [credentialDelete, setCredentialDelete] = useState();

  const [keyword, setKeyword] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  const fetchData = (page) => {
    if (companyDetails?.company_uid)
      dispatch(
        GETCREDENTIALS_REQ({
          page: page,
          limit: limit,
          company_uid: companyDetails.company_uid,
          keyword,
        })
      );
  };
  useEffect(() => {
    if (credentialUpdate.type === EDITCREDENTIAL_RESPONSE) {
      setCredentialAction();
      fetchData(1);
    }
    if (
      credentialUpdate.type === ADDCREDENTIAL_RESPONSE ||
      credentialUpdate.type === DELETECREDENTIAL_RESPONSE
    ) {
      setCredentialAction();
      fetchData(1);
    }
  }, [credentialUpdate]);

  useEffect(() => {
    fetchData(1);
  }, [keyword]);

  useEffect(() => {
    if (
      credentialAction?.credential?.credential_uid &&
      credentialAction?.credential?.credential_uid !==
        credentialDetails?.credential_uid
    ) {
      dispatch(
        GETCREDENTIAL_REQ({
          ...companyDetails,
          ...credentialAction.credential,
        })
      );
    }
    if (credentialAction?.action === "add") {
      setProviders([]);
      credentialForm.resetForm({
        values: {
          provider_name: "",
          provider_logo: "",
          provider_domain: "",
          username: "",
          password: "",
          note: "",
          url: "",
        },
      });
    }
    if (!credentialAction) {
      fetchData(credentialsList?.current_page || 1);
      dispatch(RESET_STATE("company.credentials.details"));
      setProviders([]);
      credentialForm.resetForm({
        values: {
          provider_name: "",
          provider_logo: "",
          provider_domain: "",
          username: "",
          password: "",
          note: "",
          url: "",
        },
      });
    }
  }, [credentialAction]);

  useEffect(() => {
    if (credentialDetails && credentialDetails.credential) {
      setProviders([
        {
          name: credentialDetails.provider,
          domain: credentialDetails.provider,
          logo: credentialDetails.provider_logo,
        },
      ]);
      credentialForm.resetForm({
        values: {
          provider_name: credentialDetails.provider,
          provider_domain: credentialDetails.provider,
          ...credentialDetails.credential,
        },
      });
    }
  }, [credentialDetails]);

  const credentialForm = useFormikWrapper({
    initialValues: {
      provider: "",
      url: "",
      username: "",
      password: "",
      note: "",
    },
    validationSchema: Yup.object({
      provider_name: Yup.string().required("Provider is required"),
      url: Yup.string().nullable(),
      // .required("URL is required")
      username: Yup.string().required("Username is required"),
      password: Yup.string().required("Password is required"),
      provider_domain: Yup.string().required("Provider is required"),
      note: Yup.string().nullable(),
    }),
    onSubmit: () => {
      if (credentialAction.action === "edit")
        dispatch(
          EDITCREDENTIAL_REQ({
            ...companyDetails,
            ...credentialDetails,
            ...credentialForm.values,
          })
        );
      if (credentialAction.action === "add")
        dispatch(
          ADDCREDENTIAL_REQ({
            ...companyDetails,
            ...credentialForm.values,
          })
        );
    },
  });

  return (
    <>
      <div class="h-full mt-3">
        <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
          <div class="p-2">
            <div class="flow-root">
              <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                  <div class="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                    <h3 class="text-lg font-semibold leading-6 text-gray-900">
                      Credentials
                      <span class="inline-flex items-center rounded-full bg-blue-50 ml-2 px-2 py-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                        {credentialsList?.totalCount}
                      </span>
                    </h3>
                    <div class="mt-3 sm:ml-4 sm:mt-0">
                      <div class="flex space-x-2">
                        <Search name="Credentials" onSearch={setKeyword} />
                        <FlatButton
                          onClick={() => {
                            setCredentialAction({ action: "add" });
                          }}
                          children="Add Credential"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-between min-h-[450px]">
                    <ul class="my-6 grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-2 xl:gap-x-8">
                      {credentialsList?.data?.map((credential) => (
                        <li class="rounded-xl border border-gray-200">
                          <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-3">
                            {credential.provider_logo ? (
                              <img
                                src={credential.provider_logo}
                                className="h-[48px] w-[48px] flex-none rounded-lg object-contain ring-1 ring-gray-900/10 bg-white p-1"
                                alt={credential.provider}
                              />
                            ) : (
                              <div className="h-[48px] w-[48px] flex justify-center items-center flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  // className="h-5 w-5"
                                  class="w-6 h-6"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z"
                                  />
                                </svg>
                              </div>
                            )}
                            <div class="text-sm font-medium leading-6 text-gray-900">
                              {credential.provider}
                            </div>
                            {/* More options */}
                            <div className="ml-auto [&_.menu-panel]:-left-10">
                              <DropDown
                                trigger={
                                  <>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="2"
                                      stroke="currentColor"
                                      class="w-6 h-6 stroke-gray-800"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                                      />
                                    </svg>
                                  </>
                                }
                                items={
                                  credential.created_by.coworker_uid ===
                                    user.coworker_uid || user.role === "ADMIN"
                                    ? [
                                        <span
                                          onClick={() => {
                                            setCredentialAction({
                                              action: "view",
                                              credential,
                                            });
                                          }}
                                          className="p-3 cursor-pointer w-full inline-block"
                                        >
                                          View
                                        </span>,
                                        <span
                                          onClick={() => {
                                            setCredentialAction({
                                              action: "edit",
                                              credential,
                                            });
                                          }}
                                          className="p-3 text-gray-800 cursor-pointer w-full inline-block"
                                        >
                                          Edit
                                        </span>,
                                        <span
                                          onClick={() => {
                                            setCredentialDelete(credential);
                                          }}
                                          className="p-3 text-red-500 cursor-pointer w-full inline-block"
                                        >
                                          Delete
                                        </span>,
                                      ]
                                    : [
                                        <span
                                          onClick={() => {
                                            setCredentialAction({
                                              action: "view",
                                              credential,
                                            });
                                          }}
                                          className="p-3 cursor-pointer w-full inline-block"
                                        >
                                          View
                                        </span>,
                                      ]
                                }
                              />
                            </div>
                          </div>
                          <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
                            <div class="flex justify-between gap-x-4 py-3">
                              <dt class="text-gray-500">Created by</dt>
                              <dd class="text-gray-700">
                                {credential.created_by.fullName}
                              </dd>
                            </div>
                            <div class="flex justify-between gap-x-4 py-3">
                              <dt class="text-gray-500">Last accessed at</dt>
                              <dd class="flex items-start gap-x-2">
                                <div class="text-gray-700">
                                  {credential.last_accessed_at
                                    ? moment().diff(
                                        credential.last_accessed_at,
                                        "days"
                                      ) === 0
                                      ? moment(
                                          credential.last_accessed_at
                                        ).fromNow()
                                      : moment(
                                          credential.last_accessed_at
                                        ).format("DD-MM-YYYY - hh:mm A")
                                    : "Never"}
                                </div>
                              </dd>
                            </div>
                          </dl>
                        </li>
                      ))}
                    </ul>
                    {credentialsList?.data?.length === 0 && (
                      <div className="w-full h-[350px] flex justify-center items-center text-sm text-gray-500">
                        No Credentials yet.
                      </div>
                    )}

                    <div className=" w-full flex justify-end">
                      <Paginator
                        page={credentialsList?.current_page || 1}
                        pageLimit={6}
                        totalCount={credentialsList?.totalCount || 0}
                        onPageChange={fetchData}
                        placement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Popup
          content={
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="stroke-red-600 mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to delete this credential?
              </h3>
            </>
          }
          cancelText="No, cancel"
          confirmText={`Yes, proceed`}
          confirmClass="bg-red-600 text-white"
          modalState={[credentialDelete, setCredentialDelete]}
          onConfirm={() => {
            dispatch(DELETECREDENTIAL_REQ(credentialDelete));
            setCredentialDelete();
          }}
        />
      </div>
      <Modal
        show={credentialAction?.action && credentialAction?.action !== "init"}
        size="xl"
        onClose={() => setCredentialAction()}
      >
        <Modal.Header className="capitalize pb-0 px-3 pt-3">
          {credentialAction?.action === "view" ? (
            <span className="inline-flex gap-x-4 items-center">
              {credentialAction?.credential.provider_logo && (
                <img
                  src={credentialAction?.credential.provider_logo}
                  className="h-9 w-9 flex-none rounded-lg object-contain "
                  alt={credentialAction?.credential.provider}
                />
              )}
              {credentialAction?.credential?.provider}
            </span>
          ) : (
            `${credentialAction?.action}
          Credential`
          )}
        </Modal.Header>
        <Modal.Body className="p-3">
          {credentialAction?.action === "view" ? (
            <div className="relative grid grid-cols-2 px-2.5 overflow-visible text-gray-700 gap-y-4">
              <TextBox
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                name="url"
                label="Provider URL"
                placeholder="URL"
                className="col-span-2"
              />
              <TextBox
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                name="username"
                label="Username"
                placeholder="Username"
              />
              <TextBox
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                name="password"
                label="Password"
                type="password"
                placeholder="Password"
              />
              <TextArea
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                className="col-span-2"
                name="note"
                label="Notes"
              />
            </div>
          ) : (
            <div className="relative px-2.5 overflow-visible text-gray-700 space-y-2">
              <SearchDropdown
                readOnly={credentialAction?.action === "view"}
                className="w-full"
                name="provider_domain"
                label="Provider"
                remote
                searchplaceholder="Start typing provider name"
                onSearch={(keyword) => {
                  if (keyword) {
                    fetch(
                      `https://autocomplete.clearbit.com/v1/companies/suggest?query=${keyword}`
                    )
                      .then((res) => {
                        res.json().then((data) => {
                          let _providers = [];
                          if (credentialForm.values.provider_name) {
                            _providers.push({
                              name: credentialForm.values.provider_name,
                              logo: credentialForm.values.provider_logo,
                              domain: credentialForm.values.provider_domain,
                            });
                          }
                          data.forEach((_p) => {
                            _p.name.toLowerCase() !==
                              credentialForm.values.provider_name?.toLowerCase() &&
                              _providers.push(_p);
                          });
                          if (
                            data.every(
                              (_p) =>
                                _p.name.toLowerCase() !== keyword.toLowerCase()
                            )
                          ) {
                            _providers.push({ name: keyword, domain: keyword });
                          }
                          setProviders([..._providers]);
                        });
                      })
                      .catch((err) => {
                        setProviders([{ name: keyword, domain: keyword }]);
                      });
                  } else {
                    credentialForm.values.provider_name &&
                      setProviders([
                        {
                          name: credentialForm.values.provider_name,
                          logo: credentialForm.values.provider_logo,
                          domain: credentialForm.values.provider_domain,
                        },
                      ]);
                  }
                }}
                formik={credentialForm}
                options={providers || []}
                optionId="domain"
                optionName="name"
                onSelect={(option) => {
                  if (option) {
                    credentialForm.setFieldValue("provider_logo", option.logo);
                    credentialForm.setFieldValue("provider_name", option.name);
                    // credentialForm.setFieldValue("url", option.domain);
                  } else {
                    credentialForm.setFieldValue("provider_logo", null);
                    credentialForm.setFieldValue("provider_name", "");
                    // credentialForm.setFieldValue("url", "");
                  }
                  // credentialForm.setFieldTouched("provider_domain", true);
                }}
                optionPrefix={(option) =>
                  option.logo ? (
                    <img
                      src={option.logo}
                      className="h-5 w-5 inline mr-2"
                      alt={option.name}
                    />
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6 inline mr-2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
                      />
                    </svg>
                  )
                }
              />
              <TextBox
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                name="url"
                label="Provider URL"
                placeholder="URL"
              />
              <TextBox
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                name="username"
                label="Username"
                placeholder="Username"
              />
              <TextBox
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                name="password"
                label="Password"
                type="password"
                placeholder="Password"
              />
              <TextArea
                readOnly={credentialAction?.action === "view"}
                formik={credentialForm}
                name="note"
                label="Notes"
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="p-3">
          <div
            className={`flex w-full px-2.5 flex ${
              credentialAction?.action === "view"
                ? "justify-between"
                : "justify-end"
            } gap-4`}
          >
            {credentialAction?.action === "view" ? (
              <>
                <FlatButton
                  // color="custom"
                  className="w-[100px]"
                  appearance="secondary"
                  id="cancel-button"
                  onClick={() => {
                    setCredentialAction({
                      action: "edit",
                      credential: credentialAction?.credential,
                    });
                  }}
                >
                  Edit
                </FlatButton>
                <FlatButton
                  // color="custom"
                  className="w-[100px]"
                  appearance="primary"
                  id="cancel-button"
                  onClick={() => {
                    setCredentialAction();
                  }}
                >
                  Close
                </FlatButton>
              </>
            ) : (
              <>
                <FlatButton
                  // color="custom"
                  className="w-[100px]"
                  appearance="secondary"
                  id="cancel-button"
                  onClick={() => {
                    setCredentialAction();
                  }}
                >
                  Cancel
                </FlatButton>
                <FlatButton
                  appearance="primary"
                  className="w-[100px]"
                  id="confirm-button"
                  onClick={() => {
                    credentialForm.submitForm();
                  }}
                >
                  Save
                </FlatButton>
              </>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Credentials;
